import { Reveal } from "@/components/Reveal";
import { KeyRound, FilePlus2, FileVideo, Tv } from "lucide-react";

const steps = [
  { icon: KeyRound, t: "You're logged in", d: "You are signed in as admin. The forms below let you add content." },
  { icon: FilePlus2, t: "Step 1 — Create an anime", d: "In the left form enter the title, synopsis, genres (comma separated), year/rating and upload a cover image. Click 'Create Anime'." },
  { icon: FileVideo, t: "Step 2 — Upload episode MP4s", d: "In the right form pick the anime, enter season + episode number and title, then choose the MP4 file. Many episodes? Drop them all in the 'Bulk' box — they are auto-numbered. Add subtitles (.vtt) with a language too." },
  { icon: Tv, t: "Step 3 — Watch & edit", d: "Episodes appear on the anime page instantly (seasons in separate tabs). Use the pencil icon in Library to edit an anime; change the admin password in the Security box." },
];

export const UploadGuide = () => (
  <Reveal>
    <div data-testid="upload-guide" className="kp-glass p-7 sm:p-9 border-l-2 !border-l-[#00F0FF]">
      <span className="kp-eyebrow">How to upload anime</span>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-6">
        {steps.map((s, i) => (
          <div key={i} className="flex gap-4">
            <s.icon size={20} className="text-[#00F0FF] shrink-0 mt-0.5" />
            <div>
              <h3 className="font-display text-sm font-semibold">{s.t}</h3>
              <p className="text-[#94A3B8] text-xs leading-relaxed mt-1.5">{s.d}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="text-[0.68rem] font-mono text-[#64748B] mt-6">Supported: MP4 / WebM / MOV · Cover: JPG / PNG / WebP · You can also paste a direct video URL instead of an MP4 file.</p>
      <p data-testid="upload-guide-413-note" className="text-[0.68rem] font-mono text-[#64748B] mt-2">Files are sent piece by piece (4 MB, shrinking automatically if the host complains), so large episodes never hit the "413 too large" limit. After upload the server checks the video: MKV / TS rips and non-browser audio (AC3, Opus) are converted to a playable MP4 automatically in seconds. HEVC/H.265 or 10-bit video cannot be fixed automatically — you will get a warning; re-encode those to 8-bit H.264 before uploading.</p>
    </div>
  </Reveal>
);
